import Base64url from "crypto-js/enc-base64url"
import Utf8 from "crypto-js/enc-utf8"
import SHA256 from "crypto-js/sha256"
import { v4 as uuid4 } from "uuid"

/**
 * Generate a 43 character code verifier.
 *
 * Written based on recommendation from {@link https://datatracker.ietf.org/doc/html/rfc7636#section-4.1 }
 *
 * @param seed A seed to convert to URL safe Base64 to make it usable as a PKCE code verifier.
 * If no seed is defined, a string with 32 characters is generated as a seed, and then converted into a 43 character
 * URL safe Base64 string, as per the recommendation in the RFC.
 *
 * Setting a specific seed is mainly used for unit tests, and generally a generated one should be used.
 */
export function generateCodeVerifier(seed?: string): string {
  // A UUID is 36 characters including the hyphens, but 32 without, which makes it perfect to use as a "random number"
  // we convert into URL safe Base64, to get a 43 characters code verifier, as per the RFC recommendation.
  const safeSeed = seed ?? uuid4().replaceAll("-", "")

  return Utf8.parse(safeSeed).toString(Base64url)
}

/**
 *
 * Generate PKCE code challenge.
 *
 * Written based on {@link https://datatracker.ietf.org/doc/html/rfc7636#section-4.2 }
 *
 * @param codeVerifier The code verifier to generate a challenge for.
 */
export function generateCodeChallenge(codeVerifier: string): string {
  return SHA256(codeVerifier).toString(Base64url)
}
